import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setShowInventory from "@insite/client-framework/Store/Context/Handlers/SetShowInventory";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import  { ClickablePresentationProps } from "@insite/mobius/Clickable";
import  { IconPresentationProps } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import React from "react";

/* Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox/Checkbox";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
/* Custom Code - End */

interface OwnProps {
    extendedStyles?: ShowInventoryToggleStyles;
}

export interface ShowInventoryToggleStyles {
    toggleClickable?: ClickablePresentationProps;
    toggleIcon?: IconPresentationProps;
    toggleTypography?: TypographyPresentationProps;
    // Custom Code
    wrapper?: InjectableCss;
    checkbox?: CheckboxProps;
}

export const showInventoryToggleStyles: ShowInventoryToggleStyles = {
    checkbox: {
        variant: "toggle",
        labelPosition: "right",
        sizeVariant: "small",
    },
};

export const ShowInventoryToggle = ({ extendedStyles }: OwnProps) => {
    const dispatch = useAppDispatch();
    const showInventory = useAppSelector(state => state.context.showInventory);
    const styles = useMergeStyles("showInventoryToggleStyles", showInventoryToggleStyles, extendedStyles);

    const clickShowInventoryToggleHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        dispatch(setShowInventory({ showInventory: !showInventory }));
    };

    return (
        <StyledWrapper {...styles.wrapper} className="show-inventory-toggle" /* Custom Code */>
            {/* Custom Code - Start */}
            <Checkbox
                {...styles.checkbox}
                checked={showInventory}
                onChange={clickShowInventoryToggleHandler}
                data-test-selector={showInventory ? "NotShowInventory" : "ShowInventory"}
            >
                {translate("Show Inventory")}
            </Checkbox>
            {/* Custom Code - End */}
        </StyledWrapper>
    );
};

export default ShowInventoryToggle;
